import React from "react";
import PropTypes from "prop-types";

import fields from "../../json/SubscribeEmailList.json";

import PageBody from "Common/Custom/PageBody";
import FormInput from "Common/Custom/FormInput";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import { HeadingOne } from "Common/Custom/HeadingOne";

const AddSubscriberForm = ({
  values,
  errors,
  handleChange,
  handleSubmit,
  loading,
}) => {
  const { formdata } = fields;

  return (
    <PageBody
      onSubmit={handleSubmit}
      headerchildren={<HeadingOne>Create Subscriber</HeadingOne>}
    >
      {formdata?.map((field) => (
        <FormInput
          key={field.name}
          field={field}
          value={values[field.name]}
          handleChange={handleChange}
          error={errors[field.name]}
        />
      ))}

      <FormSubmitButton
        label="Create"
        loading={loading}
        colSize="col-12"
        align="end"
      />
    </PageBody>
  );
};

AddSubscriberForm.propTypes = {
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default AddSubscriberForm;